import React, { Component }        from 'react'
import { connect }                 from 'react-redux'
import { withRouter }              from 'react-router'
import { NominationActions }       from 'actionsets'
import StyleSheet                  from 'styles'
import Dependent, { GlobalLoader } from 'containers/shared/Dependent'
import Button                      from '@material-ui/core/Button'
import Typography                  from '@material-ui/core/Typography'
import { ConfirmationDialog }      from 'components'
import { ExpressInterestForm }     from 'containers/deal_sheet'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

export class Nomination extends Component{

  constructor(props) {
    super(props)
    NominationActions.bindActions(this)
    this.state = {
      expressInterestDialogOpen: false,
      expressInterestConfirmationDialogOpen: false
    }
  }

  dependenciesMet(){
    return (!this.props.requests.filter(r => r.type === NominationActions.SHOW).length)
  }

  async dependsOn(){
    await this.actions.show({dealSheetId: this.dealSheetId}).catch(() => { /* No nomination exists */ })
  }

  get dealSheetId() {
    return this.props.match.params.id
  }

  handleShowExpressInterestDialog = () => {
    this.setState({expressInterestDialogOpen: true})
  }

  handleCancelExpressionOfInterest1 = () => {
    this.setState({expressInterestDialogOpen: false})
  }

  handleConfirmExpressionOfInterest1 = async () => {
    await this.state.submitInterestFormHandler()
    this.setState({
      expressInterestDialogOpen: false,
      expressInterestConfirmationDialogOpen: true
    })
  }

  handleConfirmExpressionOfInterest2 = () => {
    this.setState({expressInterestConfirmationDialogOpen: false})
    this.props.history.push('/deal_sheets/list/mine')
  }

  handleWithdrawInterest = () => {
    this.actions.destroy(this.props.nomination)
  }

  renderExpressionOfInterestDialog = () => {
    return (
      <ConfirmationDialog
        title="Expression of interest"
        open={this.state.expressInterestDialogOpen}
        onCancel={this.handleCancelExpressionOfInterest1}
        onConfirm={this.handleConfirmExpressionOfInterest1}
        canConfirm={!!this.state.submitInterestFormHandler}
        confirmLabel={'APPLY'}
      >
        <ExpressInterestForm submitRef={submitInterestFormHandler => this.setState({submitInterestFormHandler})}/>
      </ConfirmationDialog>
    )
  }

  renderExpressionOfInterestConfirmationDialog = () => {
    return (
      <ConfirmationDialog
        title="Expression of interest"
        open={this.state.expressInterestConfirmationDialogOpen}
        onConfirm={this.handleConfirmExpressionOfInterest2}
        canConfirm={true}
        confirmLabel={'GO TO MY DEALS'}
      >
      <Typography style={{fontWeight: 'bold'}}>
        Great! Your Expression of interest has been submitted. It will take 2-3 working days for allocation to be reviewed by the {process.env.REACT_APP_NAME} team.
        Meanwhile you will be able to check out the status of the deal in My deals section.
      </Typography>
      <Typography style={{marginBottom: '210px'}}>
        If you have not received confirmation the {process.env.REACT_APP_NAME} team in 3 working days, please contact the admin at
        <strong> {process.env.REACT_APP_SUPPORT_EMAIL}</strong>.
      </Typography>
      </ConfirmationDialog>
    )
  }

  render = () =>
    <Card className={styles.expressInterestActions}>
      <CardContent>
        {(this.props.nomination ?
          <div className={styles('hasNomination', 'nomination')}>
            <Typography className={styles.subheading} variant='subtitle1'>You do not have a current allocation for this deal.</Typography>
            <Typography variant='subtitle1'>You have indicated you would like to purchase up to:</Typography>
            <Typography className={styles.amount} variant='h6'>{this.props.nomination.size}{this.props.nomination.currency.code}</Typography>
            <br/>
            <Button onClick={this.handleShowExpressInterestDialog} variant='contained' color="primary">Revise</Button>&nbsp;
            <Button onClick={this.handleWithdrawInterest} variant='contained' color="accent">Withdraw</Button>
          </div>:
          <div className={styles.noNomination}>
            <Typography className={styles.subheading} variant='subtitle1'>You do not have a current allocation for this deal.</Typography>
            <Typography className={styles.body1} variant='body1'>If you would like an allocation for this deal you can submit an expression of interest.</Typography>
            <Button onClick={this.handleShowExpressInterestDialog} variant='contained' color="accent">Submit an expression of interest</Button>
          </div>
        )}
        { this.renderExpressionOfInterestDialog() }
        { this.renderExpressionOfInterestConfirmationDialog() }
      </CardContent>
    </Card>
}

export const styles = StyleSheet({
  expressInterestActions: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
  },
  amount: {
    textDecoration: 'underline'
  },
  body1: {
    margin: 15
  },
  subheading: {
    margin: 15
  },
  hasNomination: {

  },
  noNomination: {

  }
})

export default connect(({nominations}) => nominations)(withRouter(Dependent({loader: GlobalLoader, wrapperClassName: styles.wrapper})(Nomination)))